export const loadState = () => {
    try {
      const serializedState = sessionStorage.getItem("state");
      if (serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      return undefined;
    }
  };
  
  export const saveState = (state) => {
    try {
      const serializedState = JSON.stringify(state);
      sessionStorage.setItem("state", serializedState);
    } catch (err) {
      console.log(err);
    }
  };
  
  export const clearState = (state) => {
    try {
      sessionStorage.setItem("state", "");
    } catch (err) {
      console.log(err);
    }
  };
  